<template>
  <div class="productContainer">
    <!-- <h1 style="color: yellowgreen">Temp1 --- {{ route.params.name }}</h1> -->
    <BMain />
    <BVideo />
    <BTabs />
    <BQuestion />
  </div>
</template>

<script setup>
import BMain from "./components/BMain.vue";
import BVideo from "./components/BVideo.vue";
import BTabs from "./components/BTabs.vue";
import BQuestion from "./components/BQuestion.vue";

const route = useRoute();
logInfo("route.params", route.params);
</script>

<style lang="less" scoped>
.productContainer {
  //  border: 1px solid palevioletred;
  max-width: 1374px;
  margin: 0 auto;
  min-height: 1000px;

  //   padding-bottom: 80px;
}
</style>
